import { Spin } from "antd";
import { Navigate, Outlet } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";
import { DEFAULT_AUTHENTICATED_HOME } from "@/lib/routes";

/**
 * Owner-only guard for /billing/*. Non-owners are redirected to /chat.
 * While the profile is still loading, render a small spinner.
 */
export function RequireBilling() {
  const { profileLoaded, canManageBilling } = useProfile();

  if (!profileLoaded) {
    return (
      <div className="flex h-full items-center justify-center p-8">
        <Spin />
      </div>
    );
  }

  if (!canManageBilling) {
    return <Navigate to={DEFAULT_AUTHENTICATED_HOME} replace />;
  }

  return <Outlet />;
}
